import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { NgFor } from '@angular/common';
import { displayedLinks, DisplayLink } from '../../utils/displayed-links';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [MatListModule, MatDividerModule, RouterLink, RouterLinkActive, NgFor],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss'
})
export class SideNavComponent {
  @Input() authResolved = true;
  @Input() isAuthenticated = false;
  @Input() isAdmin = false;
  @Output() logout = new EventEmitter<void>();
  @Output() navAction = new EventEmitter<void>();

  get links(): DisplayLink[] {
    if (!this.authResolved) return displayedLinks.filter(l => !l.requiresAuth && !l.requiresAdmin);
    return displayedLinks.filter(l => {
      if (l.requiresAdmin && !this.isAdmin) return false;
      if (l.requiresAuth && !this.isAuthenticated) return false;
      if (l.requiresUnauth && this.isAuthenticated) return false;
      return true;
    });
  }
}
